export type Jurusan = {
  master_jurusan_id: string;
  kode_jurusan: string;
  nama_jurusan: string;
  master_jurusan_parent: string;
  master_fakultas_id: string;
  kode_fakultas: string;
  program: string;
  created_at: string;
  updated_at: string | null;
};

export type JurusanResponse = {
  datas: Jurusan[];
  is_next: boolean;
  status: string;
};

import { apiClient } from "@/lib/api-client";

export const fetchJurusan = async ({ pageParam = 1 }: { pageParam?: number } = {}): Promise<JurusanResponse> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  return apiClient<JurusanResponse>(`${baseUrl}/api/v1/master-jurusan?page=${pageParam}`);
};
